(function() {
  // --- State ---
  let zoomUrls = [];
  let zoomIndex = 0;
  let zoomState = { scale: 1, translateX: 0, translateY: 0 };
  let cleanupFn = null;

  // --- Helper: clamp translation so image doesn't leave empty space ---
  function clampTranslation(img, scale, tx, ty) {
    const naturalW = img.naturalWidth * scale;
    const naturalH = img.naturalHeight * scale;
    const container = img.parentElement;
    const containerW = container.clientWidth;
    const containerH = container.clientHeight;
    const maxTx = Math.max(0, (naturalW - containerW) / 2);
    const maxTy = Math.max(0, (naturalH - containerH) / 2);
    return {
      tx: Math.min(maxTx, Math.max(-maxTx, tx)),
      ty: Math.min(maxTy, Math.max(-maxTy, ty))
    };
  }


    // --- Attach pan/zoom interactions ---
  function setupZoomInteractions() {
    const overlay = document.getElementById('image-zoom-overlay');
    const container = document.getElementById('image-zoom-container');
    const img = document.getElementById('image-zoom-img');
    const resetBtn = document.getElementById('image-zoom-reset');

    let isPanning = false;
    let startX, startY, startTranslateX, startTranslateY;
    let initialPinchDistance = 0;
    let pinchStartScale = 1;
    let pinchStartImgLeft = 0, pinchStartImgTop = 0;  // NEW – actual image offset at pinch start

    function updateTransform() {
      const { tx, ty } = clampTranslation(img, zoomState.scale, zoomState.translateX, zoomState.translateY);
      zoomState.translateX = tx;
      zoomState.translateY = ty;
      img.style.transform = `translate(${tx}px, ${ty}px) scale(${zoomState.scale})`;
      resetBtn.classList.toggle('visible', zoomState.scale !== 1 || tx !== 0 || ty !== 0);
    }

    function onWheel(e) {
      e.preventDefault();
      const rect = img.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;
      const oldScale = zoomState.scale;
      const zoomSpeed = 0.1;
      zoomState.scale = e.deltaY < 0
        ? Math.min(zoomState.scale + zoomSpeed, 5)
        : Math.max(zoomState.scale - zoomSpeed, 0.5);
      const scaleChange = zoomState.scale / oldScale;
      zoomState.translateX = mouseX - scaleChange * (mouseX - zoomState.translateX);
      zoomState.translateY = mouseY - scaleChange * (mouseY - zoomState.translateY);
      updateTransform();
    }

    function onPointerDown(e) {
      if (e.target !== img) return;
      isPanning = true;
      startX = e.clientX;
      startY = e.clientY;
      startTranslateX = zoomState.translateX;
      startTranslateY = zoomState.translateY;
      img.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
      if (!isPanning) return;
      zoomState.translateX = startTranslateX + (e.clientX - startX);
      zoomState.translateY = startTranslateY + (e.clientY - startY);
      updateTransform();
    }

    function onPointerUp(e) {
      isPanning = false;
      if (img.hasPointerCapture(e.pointerId)) img.releasePointerCapture(e.pointerId);
    }

    function onTouchStart(e) {
      if (e.touches.length === 2) {
        isPanning = false;
        initialPinchDistance = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        pinchStartScale = zoomState.scale;

        // Capture the image’s actual position relative to the container
        const imgRect = img.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        pinchStartImgLeft = imgRect.left - containerRect.left;
        pinchStartImgTop  = imgRect.top  - containerRect.top;
      }
    }

    function onTouchMove(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        const currentDistance = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        if (initialPinchDistance > 0) {
          const newScale = Math.min(5, Math.max(0.5, pinchStartScale * (currentDistance / initialPinchDistance)));
          const scaleChange = newScale / pinchStartScale;
          const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
          const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
          const containerRect = container.getBoundingClientRect();

          // Use the real image offset captured at pinch start
          const pointX = ((midX - containerRect.left) - pinchStartImgLeft) / pinchStartScale;
          const pointY = ((midY - containerRect.top)  - pinchStartImgTop)  / pinchStartScale;
          zoomState.scale = newScale;
          zoomState.translateX = (midX - containerRect.left) - pointX * newScale;
          zoomState.translateY = (midY - containerRect.top)  - pointY * newScale;
          updateTransform();
        }
      }
    }

    function onTouchEnd(e) {
      if (e.touches.length < 2) initialPinchDistance = 0;
    }

    function onDoubleClick() {
      zoomState = { scale: 1, translateX: 0, translateY: 0 };
      updateTransform();
    }

    // Clean up previous listeners if any
    if (cleanupFn) cleanupFn();

    container.addEventListener('wheel', onWheel, { passive: false });
    container.addEventListener('pointerdown', onPointerDown);
    container.addEventListener('pointermove', onPointerMove);
    container.addEventListener('pointerup', onPointerUp);
    container.addEventListener('pointercancel', onPointerUp);
    container.addEventListener('touchstart', onTouchStart, { passive: false });
    container.addEventListener('touchmove', onTouchMove, { passive: false });
    container.addEventListener('touchend', onTouchEnd);
    container.addEventListener('dblclick', onDoubleClick);

    cleanupFn = () => {
      container.removeEventListener('wheel', onWheel);
      container.removeEventListener('pointerdown', onPointerDown);
      container.removeEventListener('pointermove', onPointerMove);
      container.removeEventListener('pointerup', onPointerUp);
      container.removeEventListener('pointercancel', onPointerUp);
      container.removeEventListener('touchstart', onTouchStart);
      container.removeEventListener('touchmove', onTouchMove);
      container.removeEventListener('touchend', onTouchEnd);
      container.removeEventListener('dblclick', onDoubleClick);
    };
  }

  // --- Open the zoom overlay ---
  function openImageZoom(urls, startIndex) {
    const overlay = document.getElementById('image-zoom-overlay');
    const img = document.getElementById('image-zoom-img');
    const resetBtn = document.getElementById('image-zoom-reset');
    const prevBtn = document.getElementById('zoom-prev');
    const nextBtn = document.getElementById('zoom-next');

    zoomUrls = urls;
    zoomIndex = startIndex;

    if (urls.length > 1) {
      prevBtn.style.display = 'block';
      nextBtn.style.display = 'block';
    } else {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    img.src = urls[zoomIndex];
    zoomState = { scale: 1, translateX: 0, translateY: 0 };
    img.style.transform = 'translate(0px, 0px) scale(1)';
    resetBtn.classList.remove('visible');
    overlay.classList.add('active');
    setupZoomInteractions();
  }

  // --- Close overlay ---
  function closeImageZoom() {
    const overlay = document.getElementById('image-zoom-overlay');
    overlay.classList.remove('active');
    if (cleanupFn) {
      cleanupFn();
      cleanupFn = null;
    }
  }

  // --- Navigate to adjacent image ---
  function goToZoomImage(newIndex) {
    if (newIndex < 0 || newIndex >= zoomUrls.length) return;
    zoomIndex = newIndex;
    const img = document.getElementById('image-zoom-img');
    img.src = zoomUrls[zoomIndex];
    zoomState = { scale: 1, translateX: 0, translateY: 0 };
    img.style.transform = 'translate(0px, 0px) scale(1)';
    document.getElementById('image-zoom-reset').classList.remove('visible');
  }

  // --- Global close / navigation handlers ---
  document.addEventListener('click', function(e) {
    const overlay = document.getElementById('image-zoom-overlay');
    if (!overlay || !overlay.classList.contains('active')) return;
    if (e.target.id === 'image-zoom-close' || e.target.id === 'image-zoom-overlay' || e.target.id === 'image-zoom-container') {
      closeImageZoom();
    }
    if (e.target.id === 'zoom-prev') {
      goToZoomImage(zoomIndex - 1);
    }
    if (e.target.id === 'zoom-next') {
      goToZoomImage(zoomIndex + 1);
    }
    if (e.target.id === 'image-zoom-reset') {
      zoomState = { scale: 1, translateX: 0, translateY: 0 };
      const img = document.getElementById('image-zoom-img');
      img.style.transform = 'translate(0px, 0px) scale(1)';
      e.target.classList.remove('visible');
    }
  });

  document.addEventListener('keydown', function(e) {
    const overlay = document.getElementById('image-zoom-overlay');
    if (!overlay || !overlay.classList.contains('active')) return;
    if (e.key === 'Escape') closeImageZoom();
  });

  // --- Generic image trigger: click any image with data-zoom-images ---
    function attachZoomTriggers() {
        document.querySelectorAll('[data-zoom-images]').forEach(img => {
        if (img.dataset.zoomAttached === 'true') return;
        img.dataset.zoomAttached = 'true';
        img.addEventListener('click', function(e) {
            if (!e.isTrusted) return;   // ← add this
            e.stopPropagation();
            try {
            const urls = JSON.parse(img.dataset.zoomImages);
            const start = parseInt(img.dataset.zoomIndex, 10) || 0;
            if (urls && urls.length) openImageZoom(urls, start);
            } catch (err) {
            console.error('Invalid data-zoom-images JSON', err);
            }
        });
        });

        // Also support gallery containers: .image-gallery with data-images
        document.querySelectorAll('.image-gallery[data-images]').forEach(gallery => {
        if (gallery.dataset.zoomGalleryAttached === 'true') return;
        gallery.dataset.zoomGalleryAttached = 'true';
        gallery.addEventListener('click', function(e) {
            if (!e.isTrusted) return;   // ← add this
            const galleryImage = e.target.closest('.gallery-image');
            if (!galleryImage) return;
            try {
            const urls = JSON.parse(gallery.dataset.images);
            const index = parseInt(galleryImage.dataset.index, 10) || 0;
            if (urls && urls.length) openImageZoom(urls, index);
            } catch (err) {
            console.error('Invalid data-images JSON', err);
            }
        });
        });
    }

  // Run on load and whenever DOM changes (optional)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachZoomTriggers);
  } else {
    attachZoomTriggers();
  }

    // Product gallery zoom (works without Liquid changes)
  function attachGalleryZoom() {
  document.querySelectorAll('media-gallery').forEach(gallery => {
    if (gallery.dataset.zoomGalleryAttached === 'true') return;
    gallery.dataset.zoomGalleryAttached = 'true';

    gallery.addEventListener('click', function(e) {
      if (!e.isTrusted) return;

      // Ignore clicks on thumbnails or their children
      if (e.target.closest('.thumbnail-list__item')) return;
      if (e.target.closest('slider-component[id^="GalleryThumbnails-"]')) return;

      // Also ignore clicks on slider arrows / counter
      if (e.target.closest('.slider-button')) return;

      // 1. Get only visible thumbnails (StarApps filters them)
      const thumbItems = Array.from(gallery.querySelectorAll('.thumbnail-list__item'))
        .filter(item => item.offsetParent !== null);

      if (thumbItems.length === 0) return;

      // 2. Find the active thumbnail (aria-current="true")
      const activeThumb = thumbItems.find(item =>
        item.querySelector('[aria-current="true"]')
      ) || thumbItems[0];

      // 3. Build full‑res URLs from visible thumbnails
      const urls = thumbItems.map(item => {
        const img = item.querySelector('img');
        return img ? img.src.split('?')[0] : null;
      }).filter(Boolean);

      // 4. Determine index of the active thumbnail
      const index = thumbItems.indexOf(activeThumb);

      if (index >= 0 && index < urls.length) {
        e.preventDefault();
        e.stopPropagation();
        window.openImageZoom(urls, index);
      }
    });
  });
}

    // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(attachGalleryZoom, 300));
  } else {
    setTimeout(attachGalleryZoom, 300);
  }

  window.attachGalleryZoom = attachGalleryZoom;
  window.openImageZoom = openImageZoom;
  window.closeImageZoom = closeImageZoom;
})();